import { render, staticRenderFns } from "./AccountComp.vue?vue&type=template&id=70610acb&scoped=true&"
import script from "./AccountComp.vue?vue&type=script&lang=js&"
export * from "./AccountComp.vue?vue&type=script&lang=js&"
import style0 from "./AccountComp.vue?vue&type=style&index=0&id=70610acb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70610acb",
  null
  
)

export default component.exports